// src/content/stepVideos.js
// STATUS: active | UPDATED: 2026-10-19
// LOG:
//   2026-10-19  New. The slot a demonstration video sits in, per step and per
//               teaching section. Empty until Jazz's footage is cut.
// NEXT: the first clips from the shoot day at the prototype store.
//
// WHY THE SLOT EXISTS BEFORE ANY VIDEO DOES. Tyler, 2026-10-19: "Every
// section needs a video example." steps.json had no video field on any of the
// thirteen steps, so the product had nowhere to put a clip, and the shoot day
// in Jazz's report would have produced footage with no home. This is the
// home, and adding a clip is one entry here rather than a code change.
//
// REAL FOOTAGE ONLY. Tyler, the same day: "AI videos are not recommended at
// all. We use real videos and we enhance them." Every clip here is Jazz or a
// floor he trained, filmed for real and then cleaned up.
//
// AN EMPTY SLOT RENDERS NOTHING. No frame, no placeholder, no "coming soon".
// An empty video box on a step is a promise the product has not kept, which is
// the fake data this repo forbids in a different costume.
//
// THE SECTIONS ARE THE THREE THAT TEACH: learn, words (the Word Tracks tab) and
// practice. The check is a test, not a lesson, and gets no video.
//
// THE ID IS THE PROVIDER'S ID, NEVER A URL, so nothing in this file can point
// a learner anywhere else. YouTube plays from youtube-nocookie and suits an
// unlisted clip. Vimeo can be locked to this domain, which is the better fit
// for a paid product; that plan is Tyler's call. An unlisted Vimeo clip needs
// its privacy hash, `h`. tests/step-videos.test.mjs holds every rule above.

export const SECTIONS = ['learn', 'words', 'practice']

export const PROVIDERS = ['youtube', 'vimeo']

// slug -> { learn?: Clip, words?: Clip, practice?: Clip }
// Clip: { provider: 'youtube' | 'vimeo', id: string, h?: string, title: string }
export const STEP_VIDEOS = {}

export function videoFor(slug, section) {
  const entry = STEP_VIDEOS[slug]
  return (entry && entry[section]) || null
}

export function embedUrl(clip) {
  if (!clip || !clip.id) return null
  if (clip.provider === 'youtube') {
    return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(clip.id)}?rel=0&modestbranding=1`
  }
  if (clip.provider === 'vimeo') {
    const hash = clip.h ? `&h=${encodeURIComponent(clip.h)}` : ''
    return `https://player.vimeo.com/video/${encodeURIComponent(clip.id)}?dnt=1${hash}`
  }
  return null
}
